<aux-table-panel class="pb-7">
  <div class="p-4">
    <div class="flex items-center justify-end space-x-4">
      <aux-button
        variant="secondary"
        [iconSize]="20"
        icon="Eye"
        label="View Journal Entries"
        (click)="viewJournalEntries()"
        data-pendo-id="je-configuration-back-to-in-month-adjustments"
      />
      <div class="h-[40px] border-r border-r-aux-gray-light-2"></div>
      <aux-button
        variant="secondary"
        [iconSize]="20"
        icon="FileExport"
        label="Export"
        data-pendo-id="je-configuration-excel-export-button"
        (click)="onExport()"
      />
      @if (editMode()) {
        <aux-button variant="secondary" label="Cancel" (click)="onCancel()" />

        <aux-button
          [disabled]="!!saveBtnDisabled()"
          [auxTooltip]="saveBtnDisabled()"
          variant="success"
          label="Save"
          (click)="onSave()"
        />
      } @else if (hasEditHierarchyFF()) {
        <aux-button
          [disabled]="!!editBtnDisabled().length"
          [auxTooltip]="editBtnDisabled().length === 1 ? editBtnDisabled()[0] : ''"
          [template]="editBtnDisabled().length > 1 ? errorArrayTooltip : undefined"
          label="Edit"
          classList="px-[20px]"
          (clickEmit)="editMode.set(true)"
        />
        <ng-template #errorArrayTooltip>
          <div class="rounded-[4px] py-2 pl-6 pr-4 text-white">
            <ul class="list-disc whitespace-nowrap">
              @for (err of editBtnDisabled(); track $index) {
                <li>{{ err }}</li>
              }
            </ul>
          </div>
        </ng-template>
      }
    </div>
    <div class="pt-4 italic text-black">
      Select up to two attributes that align with your General Ledger configuration (e.g. "Account"
      + "Department"). This determines how expenses and accruals are calculated on the Close Summary
      and Journal Entry outputs.
    </div>
  </div>

  @if (loading()) {
    <aux-table-skeleton />
  } @else {
    <div class="border-t">
      <div class="bg-white py-[10px] pl-4 font-bold leading-[24px]">Data Attribute Grouping</div>
      <div class="relative col-span-3 w-full border-t border-aux-gray-dark">
        <div
          class="absolute h-[2px] rounded-full bg-black"
          style="width: calc(100% - 20px); top: -2px; left: 10px"
        ></div>
      </div>
      <div class="m-[10px]">
        @for (item of hierarchyOptions(); track item.value) {
          <div>
            <div class="flex items-center">
              <aux-checkbox
                class="ml-[10px] pb-[5px] pt-[5px]"
                [checked]="hierarchy().includes(item.value)"
                [disabled]="
                  !editMode() ||
                  (hierarchy().length === 2 && !hierarchy().includes(item.value)) ||
                  item.disabled
                "
                auxTooltip
                [template]="
                  item.disabled && editMode() && hierarchy().length !== 2
                    ? tooltipTemplate
                    : undefined
                "
                [hideLabelCursor]="true"
                [editMode]="editMode()"
                (customChange)="onHierarchySet($event, item.value)"
              >
                <p>{{ item.label }}</p>
              </aux-checkbox>
            </div>
          </div>
        }
        <p class="italic">OR</p>
        <aux-checkbox
          class="ml-[10px] pb-[5px] pt-[5px]"
          [checked]="hierarchy().at(0) === 'Cost Category'"
          [disabled]="!editMode()"
          [hideLabelCursor]="true"
          [editMode]="editMode()"
          (customChange)="onCostCategorySet($event)"
        >
          <p>Cost Category (Services, Pass-throughs, Investigator)</p>
        </aux-checkbox>
      </div>
    </div>
    <ng-template #tooltipTemplate>
      <p class="space-y-1">
        Attribute must be populated for every activity to use in JE Configuration.
      </p>
      <p class="space-y-1">This can be updated on the Vendor Budget page.</p>
    </ng-template>
  }
</aux-table-panel>
